import styled from "@emotion/styled";
import { InfoCircle16Icon } from "@kaltura/ds-react-icons";
import { Tooltip } from "@kaltura/ds-react-components";
import { baseFormLabelClasses } from "./../../base-form-label/BaseFormLabel";
import { FormLabel, FormLabelProps } from "../form-label/FormLabel";

export interface FormLabelWithDescriptionProps extends FormLabelProps {
    description?: string;
}

const StyledFormLabelWithDescription = styled("div")(({ theme }) => ({
    display: "flex",
    columnGap: theme.spacing(1),
    alignItems: "center",
}));

const StyledSpan = styled("div")(({ theme }) => ({
    height: 16,
    width: 16,
}));

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
    [`& .${baseFormLabelClasses.label}`]: {
        paddingBottom: 0,
    },
    [`&.${baseFormLabelClasses.root}`]: {
        marginBottom: 0,
    },
}));

export function FormLabelWithDescription({ description, className, ...rest }: FormLabelWithDescriptionProps) {
    return (
        <StyledFormLabelWithDescription className={className}>
            <StyledFormLabel {...rest} />
            {description && (
                <Tooltip title={description}>
                    <StyledSpan tabIndex={0} role={"img"}>
                        <InfoCircle16Icon />
                    </StyledSpan>
                </Tooltip>
            )}
        </StyledFormLabelWithDescription>
    );
}

export default FormLabelWithDescription;
